import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const AgendaDialogs = ({
  postponeDialog,
  completeDialog,
  handlePostponeClose,
  handlePostponeConfirm,
  handleCompleteClose,
  handleCompleteConfirm,
  handleDateChange
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Postpone Dialog */}
      <Dialog 
        open={postponeDialog.open} 
        onClose={postponeDialog.isLoading ? undefined : handlePostponeClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t('agenda.postponeTask')}</DialogTitle>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              value={postponeDialog.selectedDate}
              onChange={handleDateChange}
              minDate={dayjs().add(1, 'day')}
              disablePast
              disabled={postponeDialog.isLoading}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handlePostponeClose}
            disabled={postponeDialog.isLoading}
          >
            {t('common.cancel')}
          </Button>
          <Button 
            onClick={handlePostponeConfirm} 
            variant="contained" 
            color="primary"
            disabled={postponeDialog.isLoading}
            startIcon={postponeDialog.isLoading ? <CircularProgress size={20} /> : null}
          >
            {postponeDialog.isLoading ? t('common.processing') : t('common.accept')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Complete Dialog */}
      <Dialog
        open={completeDialog.open}
        onClose={completeDialog.isLoading ? undefined : handleCompleteClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t('agenda.markAsDone')}</DialogTitle>
        <DialogActions>
          <Button 
            onClick={handleCompleteClose}
            disabled={completeDialog.isLoading}
          >
            {t('common.cancel')}
          </Button>
          <Button 
            onClick={handleCompleteConfirm} 
            variant="contained" 
            color="primary"
            disabled={completeDialog.isLoading}
            startIcon={completeDialog.isLoading ? <CircularProgress size={20} /> : null}
          >
            {completeDialog.isLoading ? t('common.processing') : t('common.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AgendaDialogs; 